import { memo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./checkoutstep.css";

const CheckoutStep = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleStepClick = (path) => {
    // Payment page se back ja sakte hain
    if (pathname.includes("/checkout/payment")) {
      navigate(path);
    }

    // Address page se sirf Cart par ja sakte hain
    if (pathname === "/checkout/init" && path === "/cart") {
      navigate(path);
    }
  };

  // Step-wise active status
  const getStepClass = (step) => {
    if (pathname === "/cart") {
      return step === "cart" ? "active" : "";
    }

    if (pathname === "/checkout/init") {
      return ["cart", "address"].includes(step) ? "active" : "";
    }

    if (pathname.includes("/checkout/payment")) {
      return ["cart", "address", "payment"].includes(step)
        ? "active"
        : "";
    }

    return "";
  };

  // Click allowed check
  const isClickable = (path) => {
    if (pathname.includes("/checkout/payment")) {
      return path !== "/checkout/payment";
    }

    if (pathname === "/checkout/init") {
      return path === "/cart";
    }

    return false;
  };

  return (
    <div className="checkout-steps">

      {/* CART */}
      <div
        className={`step ${getStepClass("cart")}`}
        onClick={() => handleStepClick("/cart")}
        style={{
          cursor: isClickable("/cart") ? "pointer" : "default",
        }}
      >
        <div className="checkbasket">
          <i className="bi bi-cart2"></i>
        </div>
        CART
      </div>

      <div className="line"></div>

      {/* ADDRESS */}
      <div
        className={`step ${getStepClass("address")}`}
        onClick={() => handleStepClick("/checkout/init")}
        style={{
          cursor: isClickable("/checkout/init")
            ? "pointer"
            : "default",
        }}
      >
        <div className="checkbasket">
          <i className="bi bi-pencil"></i>
        </div>
        ADDRESS
      </div>

      <div className="line"></div>

      {/* PAYMENT */}
      <div
        className={`step ${getStepClass("payment")}`}
        onClick={() => handleStepClick("/checkout/payment")}
        style={{
          cursor: isClickable("/checkout/payment")
            ? "pointer"
            : "default",
        }}
      >
        <div className="checkbasket">
          <i className="bi bi-currency-rupee"></i>
        </div>
        PAYMENT
      </div>

    </div>
  );
};

export default memo(CheckoutStep);